import React from 'react'
import { useInsiderCampaignLoader } from 'src/hooks/useInsiderCampaignLoader'
import useWindowDimensions from 'src/hooks/useWindowDimensions'
import InsiderCartDefaultShelf from './InsiderShelfCartDefault/InsiderCartDefaultShelf'
import InsiderCartShelfCampaign from './InsiderShelfCartCampaign/InsiderCartShelfCampaign'
import './shelf-minicart.scss'
import InsiderMinicartSkeleton from './InsiderMiniCartSkeleton/InsiderMinicartSkeleton'

interface Props {
  campaignId?: string
  campaignIdForMobile?: string
  campaignIdForTablet?: string
  defaultCollectionId: string
  title: string
  headingTitle?: HeadingLevel
  fontFamily?: string
}

const InsiderShelfCart: React.FC<Props> = ({
  campaignId,
  campaignIdForMobile,
  campaignIdForTablet,
  defaultCollectionId,
  title,
  headingTitle = 'h2',
  fontFamily = '1',
}) => {
  const { isMobile, isWindowBiggerThanTablet } = useWindowDimensions()
  const isTablet = !isMobile && !isWindowBiggerThanTablet
  const isDesktop = !isMobile && isWindowBiggerThanTablet

  const rawCampaignId =
    (isMobile && campaignIdForMobile) ||
    (isTablet && campaignIdForTablet) ||
    (isDesktop && campaignId) ||
    undefined

 const {
  isLoading,
  hasProducts,
} = useInsiderCampaignLoader(rawCampaignId, 5000)

const itemsToDisplay = isDesktop ? 3 : 2;

  if (isLoading) {

    return (
      <section className="insider-shelf-minicart">
        <div className="insider-shelf__slider">
          {Array.from({ length: itemsToDisplay }).map((_, index) => (
            <InsiderMinicartSkeleton key={index} />
          ))}
        </div>
      </section>
    );
  }

  return hasProducts && rawCampaignId ? (
    <InsiderCartShelfCampaign
      campaignId={Number(rawCampaignId)}
      insiderShelfTitle={title}
      headingTitle={headingTitle}
      fontfamily={fontFamily}
      itemsToDisplay={itemsToDisplay}
    />
  ) : (
    <InsiderCartDefaultShelf
      collectionId={defaultCollectionId}
      insiderShelfTitle={title}
      headingTitle={headingTitle}
      fontfamily={fontFamily}
      itemsToDisplay={itemsToDisplay}
    />
  )
}

export default InsiderShelfCart
